class TrainPresenter {
  constructor(view, findUseCase, deleteObjectUseCase) {
    this.view = view;
    this.findUseCase = findUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.limit = 10;
    this.current = 1;
    this.where = {
      status: "Active",
      date_exp: { $gte: new Date().toISOString().slice(0, 10) },
    };
    this.documents = [];
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      count: true,
      limit: this.limit,
      skip,
      where: this.where,
      sort: { createdAt: -1 },
      include: ["all"],
    };
    this.view.showProgress();
    return this.findUseCase
      .execute("training_links", query)
      .then(({ count, objects }) => {
        this.documents = this.documents.concat(objects);
        this.view.setCount(count);
        this.view.setLearns(this.documents);
        this.view.hideProgress();
      })
      .catch((error) => {
        this.view.hideProgress();
        this.view.showError(error);
      });
  }

  onClickLearn(learn) {
    this.view.navigateTo("/train/details", learn);
  }

  onSubmitSearch(word) {
    this.where = { ...this.where, title: { $regex: word, $options: "i" } };
    this.documents = [];
    this.current = 1;
    this.getData();
  }

  onChangeDate(where) {
    // this.init();
    this.documents = [];
    this.where.createdAt = where.createdAt;
    this.getData();
  }

  onDeleteTraining(learn) {
    const collection = "learns";
    console.log("111", learn.id);
    this.view
      .showDialog({
        title: "Delete Data?",
        message: "Are you sure you want to delete?",
      })
      .then(() => {
        this.deleteObjectUseCase
          .execute(collection, learn.id)
          .then(() => {
            this.documents = [];
            this.getData();
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        this.view.hideProgress();
        this.view.showError(error);
      });
  }
}

export default TrainPresenter;
